// Strings for the legal pages and the cookie consent banner. The documents
// themselves (privacy, terms, cookies) live in lib/auth/legal-docs.ts.
import { registerMessages } from '../i18n.svelte';

registerMessages({
  nl: {
    'consent.title': 'Cookies bij Timepeak',
    'consent.text': 'We gebruiken noodzakelijke cookies om Timepeak te laten werken. Met jouw toestemming meten we ook anoniem hoe de site wordt gebruikt en hoe onze advertenties presteren.',
    'consent.policy_link': 'Lees het cookiebeleid',
    'consent.preferences': 'Voorkeuren',
    'consent.reject': 'Weigeren',
    'consent.accept': 'Accepteren',
    'consent.prefs_title': 'Cookievoorkeuren',
    'consent.prefs_description': 'Kies welke cookies je toestaat. Je kunt je keuze altijd weer aanpassen.',
    'consent.necessary': 'Noodzakelijk',
    'consent.necessary_desc': 'Houden je ingelogd, beveiligen je account en onthouden deze keuze. Altijd aan.',
    'consent.always_on': 'Altijd aan',
    'consent.analytics': 'Analyse',
    'consent.analytics_desc': 'Google Analytics via Google Tag Manager: geanonimiseerde statistieken die ons helpen Timepeak te verbeteren.',
    'consent.marketing': 'Marketing',
    'consent.marketing_desc': 'Meta Pixel: meten welke advertenties nieuwe gebruikers opleveren.',
    'consent.reject_all': 'Alles weigeren',
    'consent.save': 'Keuze opslaan',
    'consent.accept_all': 'Alles accepteren',

    'legal.doc.privacy': 'Privacybeleid',
    'legal.doc.terms': 'Gebruiksvoorwaarden',
    'legal.doc.cookies': 'Cookiebeleid',
    'legal.toc': 'Op deze pagina',
    'legal.updated': 'Laatst bijgewerkt op {date}',
    'legal.login': 'Inloggen',
    'legal.to_app': 'Naar de app',
    'legal.other_docs': 'Meer juridische informatie',
    'legal.questions': 'Vragen over dit document?',
    'legal.questions_text': 'Mail ons via {email}, we helpen je graag.',
    'legal.consent_status': 'Jouw huidige keuze',
    'legal.consent_none': 'Je hebt nog geen keuze gemaakt. Tot die tijd plaatsen we alleen noodzakelijke cookies.',
    'legal.consent_on': 'aan',
    'legal.consent_off': 'uit',
    'legal.consent_change': 'Cookievoorkeuren aanpassen',
    'legal.translation_note': ''
  },
  en: {
    'consent.title': 'Cookies at Timepeak',
    'consent.text': 'We use necessary cookies to make Timepeak work. With your permission we also measure anonymously how the site is used and how our ads perform.',
    'consent.policy_link': 'Read the cookie policy',
    'consent.preferences': 'Preferences',
    'consent.reject': 'Decline',
    'consent.accept': 'Accept',
    'consent.prefs_title': 'Cookie preferences',
    'consent.prefs_description': 'Choose which cookies you allow. You can change your choice at any time.',
    'consent.necessary': 'Necessary',
    'consent.necessary_desc': 'Keep you signed in, protect your account and remember this choice. Always on.',
    'consent.always_on': 'Always on',
    'consent.analytics': 'Analytics',
    'consent.analytics_desc': 'Google Analytics via Google Tag Manager: anonymised statistics that help us improve Timepeak.',
    'consent.marketing': 'Marketing',
    'consent.marketing_desc': 'Meta Pixel: measure which ads bring in new users.',
    'consent.reject_all': 'Decline all',
    'consent.save': 'Save choice',
    'consent.accept_all': 'Accept all',

    'legal.doc.privacy': 'Privacy policy',
    'legal.doc.terms': 'Terms of use',
    'legal.doc.cookies': 'Cookie policy',
    'legal.toc': 'On this page',
    'legal.updated': 'Last updated on {date}',
    'legal.login': 'Sign in',
    'legal.to_app': 'Go to the app',
    'legal.other_docs': 'More legal information',
    'legal.questions': 'Questions about this document?',
    'legal.questions_text': 'Email us at {email}, we are happy to help.',
    'legal.consent_status': 'Your current choice',
    'legal.consent_none': 'You have not made a choice yet. Until then we only place necessary cookies.',
    'legal.consent_on': 'on',
    'legal.consent_off': 'off',
    'legal.consent_change': 'Change cookie preferences',
    'legal.translation_note': 'This is a translation for convenience. If the Dutch and English versions differ, the Dutch version applies.'
  }
});
